export const START_PROFIT_WELL = "START_PROFIT_WELL";

export const SEND_GTAG_REGISTRATION = 'SEND_GTAG_REGISTRATION';
export const SEND_GTAG_PAYMENT_METHOD = 'SEND_GTAG_PAYMENT_METHOD'

export const LOGOUT = "LOGOUT";